
export class Organization {
    organizationCode: string = "";
    organizationName: string = "";
    primaryLanguage: string = "";
}
